import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle, ArrowLeft } from "lucide-react";

export default function SponsorCancel() {
  return (
    <div
      data-testid="sponsor-cancel-page"
      className="min-h-screen w-full flex items-center justify-center bg-[#FDFBF7] p-6"
    >
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md rounded-3xl bg-white border border-[#E5E1D8] shadow-lg p-8 text-center"
      >
        <XCircle className="w-12 h-12 mx-auto text-[#8A9A8B]" />
        <h1 className="mt-4 font-display text-2xl font-medium text-[#2A3B2C]">
          Payment cancelled
        </h1>
        <p className="mt-2 text-sm text-[#647466]">
          Your listing wasn't charged. Come back any time to boost your
          visibility.
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex w-full items-center justify-center gap-2 h-11 rounded-full bg-[#D95D39] hover:bg-[#C54E2C] text-white text-sm font-medium transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to map
        </Link>
      </motion.div>
    </div>
  );
}
